module.exports = __webpack_public_path__ + "img/shuiguo.84dd4eed.png";